import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiClient } from "../../app/helper/axiosHelper";
import { ApiConstants } from "../../app/utils/apis/ApiConstants";

export const getDashboardAPI = createAsyncThunk(
    "dashboard/getDashboardAPI",
    async (_,{rejectWithValue}) => {
      try {
          const response = await apiClient.get(`${ApiConstants.GET_ALL_DASHBOARD_INFO}`)
          console.log('responsegetDashboardAPI :>> ', response);
        return response.data.data;
      } catch (err: any) {
        return rejectWithValue(err);
      }
    }
  );
  